import React from "react";
import { FORM_GROUP_VARIANTS } from "../../../helpers/formGroupVariants";
import { DATE_FORMAT, MOMENT_DATE_FORMAT } from "../../../helpers/constants";
import { getDateQuestionMaximumValue, getDateQuestionMinimumValue, checkDateTypeForForms, flattenQuestions } from "../../../helpers/questions/functions";
import moment from "moment";
import { FormGroup } from 'arag-ui-lib';
import CONTENT_STRINGS from "../../../helpers/contentStrings";
import QuestionEditActions from "../QuestionEditActions";

const CalendarInputType = (props) => {
    const {
        question,
        value,
        formData,
        isPlain,
        isAnswerEditModalOpen,
        application,
        questions,
        hasInlineElements,
        dateHandler,
        mapEditingQuestionOrFieldToEditingSetting,
        approvalOptions,
        openEditQuestionAnswerModal,
        checkIfPlainEditable,
        checkIfQuestionHasPendingChanges,
        openHistoryModal,
        isLabelClickable,
    } = props;
    const variant = isPlain ? FORM_GROUP_VARIANTS.PLAIN : FORM_GROUP_VARIANTS.DATE;
    // date field
    const flattened = isAnswerEditModalOpen ? flattenQuestions(application.questionsDtos) : questions;
    const minDate = getDateQuestionMinimumValue(question, formData, flattened);
    //Special handling for Birth date. It's not part of the questions array.
    const maxDate = question.isStandard ? new Date() : getDateQuestionMaximumValue(question, formData, flattened);
    const finalValue = checkDateTypeForForms(value);
    const hasPendingChanges = checkIfQuestionHasPendingChanges( question.id, application );
    const inputSize = question.tooltip && !hasPendingChanges && isPlain ? 'col-sm-8' : 'col-sm-6';
    return (
        <FormGroup
            variant={variant}
            labelSize={"col-sm-3"}
            inputSize={inputSize}
            label={question.name}
            inputProps={{
                label: value,
                required: question.isRequired,//Show the asterisk for the required field
                dateInputProps: {
                    id: `question-id-${question.id}`,
                    name: question.machineName,
                    onChange: (e) => { dateHandler(question.id, moment(e).format(MOMENT_DATE_FORMAT), minDate, maxDate); },
                    minDate: minDate,
                    maxDate: maxDate,
                    dateFormat: DATE_FORMAT,
                    selected: finalValue,
                    placeholderText: CONTENT_STRINGS.DATE_PLACEHOLDER,
                    value: finalValue,
                    required: question.isRequired,//Check if the field is empty
                    autoComplete: "off",
                },
            }}
            infoText={question.tooltip}
            hasInlineElements={hasInlineElements}
            inlineGroupElements={
                hasInlineElements
                ?
                    <div className={'col-sm-3'}>
                        <QuestionEditActions
                            checkIfPlainEditable={checkIfPlainEditable(question, question.machineName)}
                            question={question}
                            mapEditingQuestionOrFieldToEditingSetting={mapEditingQuestionOrFieldToEditingSetting}
                            approvalOptions={approvalOptions}
                            onClick={() => openEditQuestionAnswerModal({ questionAnswerForEdit: question, questionAnswer: formData[question.id] })}
                            hasPendingChanges={hasPendingChanges}
                        />
                    </div>
                : 
                    null
            }
            onLabelClick={ isLabelClickable ? () => openHistoryModal(question) : undefined }
            formGroupTestId={`policy-application-${question.machineName}`}
        />
    );
};

export default CalendarInputType;